import * as variables from './variables.js';

import * as $ from 'jquery';

import './lib/AnimationEasing';
import "./lib/AnalyticsSetup";


import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);


import { MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggerWrap: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.menu-item-has-children > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});


/* Basic Carousels */
import Carousel from './component/Carousel';
const carouselElem = document.querySelector('.carousel');
if (carouselElem) {
	new Carousel({
		analyticsCategory: 'Carousel',
		carouselEl: carouselElem as HTMLElement,
		duration: 7500,
		allowIndicatorClick: true,
		autoHeight: true,
		autoAdvance: true
	});
	// TODO: [CROST] autoAdvance is buggy, last slide to first transition changes from next to prev.
}


// AJAX Forms - Used on calcaultor pages
if ($('.ajaxForm').length > 0) {
	$('body').on('submit', '.ajaxForm', (e) => {
		const $form = $(e.target);
		const rerender = $form.attr('data-ajaxrerender');
		if (rerender != null) {
			e.preventDefault();

			const formData = $form.serialize();
			const action = $form.attr('action') ?? window.location.href.split('?')[0];

			$(rerender).load(action + " " + rerender, formData);
		}
	});
}

import lightbox from './component/Lightbox';
lightbox();

import whereToBuy from './component/WhereToBuy';
whereToBuy();

import tabs from './component/Tabs';
$(window).on('load', function () { // Needed since the tabs don't exist on page load and are created in <script type="text/template">
	tabs();
});

// Product Carousel ( home page under masthead carousel )
import productCarousel from './component/ProductCarousel/ProductCarousel';
const availableProductCarousels = $(".featured-pages");
if(availableProductCarousels.length !== 0) {
	productCarousel('.featured-pages__items');
}